<template>
  <div
    class="flex h-full w-full flex-col gap-6 p-6"
    v-if="
      (getConfigs.side_menus &&
        getConfigs.side_menus
          .map((item) => item.menu_name)
          .includes('Bests')) ||
      getSelectedAccount.broker_name == 'RICO'
    "
  >
    <div class="absolute top-0 left-0 h-[360px] w-full">
      <span class="best-bg"></span>
      <span class="gradient"></span>
    </div>
    <vue-page-transition
      name="fade-in-right"
      class="h-full z-10"
      id="div-vue-page-transition"
    >
      <router-view />
    </vue-page-transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      getSelectedAccount: "accountTypes/getSelectedAccount",
      getConfigs: "config/getConfigs",
    }),
    pageEnabled() {
      if (!this.getConfigs.side_menus) return false;
      return this.getConfigs.side_menus
        .map((item) => item.menu_name)
        .includes("Bests");
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../styles/bests.scss";
</style>
